import { Header } from '@tanstack/react-table'
import { TableInitBase } from 'utils/hooks/useTable'

export interface BatchHeaderSelectOption {
    value: string
    label: string
}

export interface BatchHeaderSelectContext<TData = any> {
    header: Header<TData, unknown>
    tableInit: TableInitBase
    selectedRows: TData[]
    selectedIds: Array<string | number>
    clearSelection: () => void
}

export interface BatchHeaderSelectMeta<TData = any> {
    options:
        | BatchHeaderSelectOption[]
        | ((context: BatchHeaderSelectContext<TData>) => BatchHeaderSelectOption[])
    selectPlaceholder: string
    applyLabel?: string
    onApply: (
        value: string,
        context: BatchHeaderSelectContext<TData>
    ) => void | Promise<void>
    disabled?: (context: BatchHeaderSelectContext<TData>) => boolean
}

type ColumnMetaWithBatchHeaderSelect<TData = any> = {
    batchHeaderSelect?: BatchHeaderSelectMeta<TData>
}

export const getBatchHeaderSelectMeta = <TData,>(
    header: Header<TData, unknown>
): BatchHeaderSelectMeta<TData> | null => {
    const meta = header.column.columnDef.meta as
        | ColumnMetaWithBatchHeaderSelect<TData>
        | undefined

    return meta?.batchHeaderSelect ?? null
}
